import Vue from "vue";
import UpdateAbsencePopup from "./UpdateAbsencePopup.vue";

export class VueUpdateAbsencePopup {
  private vm: any;
  private resolve_prom: (val: any) => void;

  constructor() {
    const Component = Vue.extend(UpdateAbsencePopup);
    this.vm = new Component({
      propsData: {
        show: false,
        absence: {},
      },
    });

    this.vm.$mount(); 
    document.body.appendChild(this.vm.$el); 

    this.vm.$on("close", (data: any) => {
      // No cerrar automáticamente el popup aquí
      // El comando decidirá si cerrar o mantener abierto según el resultado
      this.resolve_prom(data);
    });
  }

  show(absence: any): Promise<any> {
    this.vm.absence = { ...absence };
    this.vm.show = true;
    return new Promise((resolve) => {
      this.resolve_prom = resolve;
    });
  }

  close() {
    this.vm.show = false;
  }

  showErrorDialog(message: string, details: string = '') {
    // Mantener el popup abierto y mostrar el error
    if (this.vm.showErrorDialog) {
      this.vm.showErrorDialog(message, details);
    }
  }

  get errors() {
    return this.vm.errors || {};
  }

  set errors(value: any) {
    this.vm.errors = value;
  }
}
